import { useTranslation } from 'react-i18next'

import { Card, CardTitle, LineItem } from '@reveni-io/reveni-ui'

import LineItemExchangeInfo from './LineItemExchangeInfo/LineItemExchangeInfo'
import { getNewLineItemsRequested } from './helpers'
import * as Styles from './styles'

const NewLineItemsRequestedCard = ({ items, newItems }) => {
  const { t } = useTranslation()

  const newLineItemsRequested = getNewLineItemsRequested(items, newItems)

  if (!newLineItemsRequested.length) return null

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Nuevos productos solicitados')}</CardTitle>
      <Styles.ItemsContainer>
        {newLineItemsRequested?.map(item =>
          item?.exchange_info ? (
            <LineItemExchangeInfo key={item.id} item={item} cancelled={item.cancelled_from_draft} />
          ) : (
            <Styles.LineItemWrapper key={item.id} cancelled={item.cancelled_from_draft}>
              <LineItem item={item} />
            </Styles.LineItemWrapper>
          )
        )}
      </Styles.ItemsContainer>
    </Card>
  )
}

export default NewLineItemsRequestedCard
